import React, {useContext} from 'react';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import {UserContext} from './../../contexts/UserContext';

import Icon from './../../common/components/Icon';


const Wrapper = styled.div.withConfig({displayName:'-Wrapper'})`
  color: #0D609D;
  white-space: nowrap;
  display: flex;
  align-items: center;

  float: right;
`;
const MenuTrigger = styled.div.withConfig({displayName:'-MenuTrigger'})`
  position: relative;

  &:hover > *:last-child{
  max-height: 300px;
  }
`;
const MenuDropdown = styled.div.withConfig({displayName:'-MenuDropdown'})`
  position: absolute;
  top: 0px;
  right: 0px;
  max-height: 0px;
  overflow: hidden;
  min-width: 100%;
  transition: all 0.12s linear;
  cursor: pointer;
`;
const MenuWrapper = styled.div.withConfig({displayName:'-MenuWrapper'})`
  margin-top: 50px;
  padding: 15px 15px;
  background: #ffffff;
  box-shadow: 0 0 10px 1px rgba(68,102,242,0.05);
  cursor: default;
`;
const MenuItem = styled.div.withConfig({displayName:'-MenuItem'})`
  padding: 7px 5px;
  & a{
    display: flex;
    color: inherit;
  }

  &:hover{
    color: red
  }
`;
const MenuIcon = styled.div.withConfig({displayName:'-MenuIcon'})`
  position: relative;
  bottom: -1px;
  margin-right: 8px;
`;
const Name = styled.div.withConfig({displayName:'-Name'})`
  display: flex;
  cursor: pointer;
`;
const DropdownIcon = styled.div.withConfig({displayName:'-DropdownIcon'})`
  position: relative;
  bottom: -1px;
  margin-left: 10px;
  cursor: pointer;
`;
const Avatar = styled.div.withConfig({displayName:'-Avatar'})`
  border: 2px solid #0D609D;
  width: 40px;
  height: 40px;
  border-radius: 40px;
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  color: #0D609D;
  flex-shrink: 0;
`;

const UserMenu = () => {
  const {user} = useContext(UserContext);

  return (
    <Wrapper>
      <MenuTrigger>
        <Name>
          {user.JwtToken.given_name && user.JwtToken.family_name ?
            user.JwtToken.given_name + " " + user.JwtToken.family_name
          :
            user.JwtToken.email
          } <DropdownIcon><Icon color={"#303030"} size="12px" name={"arrow-down"} /></DropdownIcon>
        </Name>
        <MenuDropdown>
          <MenuWrapper>
            {user.Level === "Editor" || user.Level === "Publisher" || user.Level === "Admin" ? 
              <MenuItem>
                <Link to="/admin"><MenuIcon><i className="fa-solid fa-gauge"></i></MenuIcon> Admin</Link>
              </MenuItem>
            : null }
            {/*<MenuItem>
              <Link to="/settings"><MenuIcon><Icon name={"settings"} color={"#303030"} size="16px" /></MenuIcon> Settings</Link>
            </MenuItem>
            <MenuSpacer />*/}
            <MenuItem>
              <Link to="/auth/login"><MenuIcon><i className="fa-solid fa-right-from-bracket"></i></MenuIcon> Sign out</Link>
            </MenuItem>
          </MenuWrapper>
        </MenuDropdown>
      </MenuTrigger>
      <Avatar>
        {user.JwtToken.given_name && user.JwtToken.given_name.length > 0 ? user.JwtToken.given_name[0] : ""}
        {user.JwtToken.family_name && user.JwtToken.family_name.length > 0 ? user.JwtToken.family_name[0] : ""}
      </Avatar>
      {/*<Link to='/admin/account'>
        <Avatar>
          {user.given_name && user.given_name.length > 0 ? user.given_name[0] : "?"}
        </Avatar>
      </Link>*/}
    </Wrapper>
  )
}

export default UserMenu;
